import { useSearchParams } from "react-router";
import BaseCallbackPage, { CallbackStatuses } from "./BaseCallbackPage";
import useInBrainCallbackDirect from "../../hooks/useInBrainCallbackDirect";
import { CallbackResult } from "interfaces/CallbackResult";

function DynataEngageCallbackPageDirect() {
  const [searchParams] = useSearchParams();

  const callbackStatus =
    searchParams.get("disposition") === "1"
      ? CallbackStatuses.Complete
      : CallbackStatuses.Disqualification;

  const callbackResult: CallbackResult = {
    reward: Number(searchParams.get("reward") || 0),
    productType: searchParams.get("productType") || "SurveysWall",
    surveyId: searchParams.get("surveyId") || "",
    surveyCategoryIds: searchParams.get("surveyCategoryIds")
      ? searchParams.get("surveyCategoryIds")!.split(",").map(Number)
      : [],
    placementId: searchParams.get("placementId") || "",
    redirectLink: searchParams.get("redirectLink") || "",
    nextSurvey: undefined,
  };

  const {
    isLoading,
    reward,
    displayedReward,
    currencyName,
    isRewardVisibilityDisabled,
    isDisqualificationDisabled,
    showAnimatedCta,
    navigateNext,
  } = useInBrainCallbackDirect(callbackStatus, callbackResult);

  return (
    <BaseCallbackPage
      isLoading={isLoading}
      callbackStatus={callbackStatus}
      currencyName={currencyName!}
      reward={reward}
      displayedReward={displayedReward}
      isRewardVisibilityDisabled={isRewardVisibilityDisabled}
      isDisqualificationDisabled={isDisqualificationDisabled}
      showAnimatedCta={showAnimatedCta}
      closeView={navigateNext}
    />
  );
}

export default DynataEngageCallbackPageDirect;
